import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";

export default function News(props) {
  return (
    <div className="banner" id="news">
      <a href="/" className="left">
        <img alt="Speedoc logo" src={process.env.REACT_APP_LOGO_SVG} />
      </a>
      <div className="right">
        <div className="newsContent">
          <p>COVID-19 situation</p>
          <a href="https://speedoc.com/sg/wuhan-coronavirus-updates-realtime-singapore/">
            <span className="fontLight">Learn more</span>
            <br />
            How can Speedoc help you?
            <br />
            <IoIosArrowRoundForward />
          </a>
        </div>
      </div>
    </div>
  );
}
